import { Container, Navbar, Dropdown } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import { Button } from "flowbite-react";
import Logo from '../../assets/images/admin-logo.svg'
import avtar from '../../assets/images/avtar-male.png'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import defaultProfle from "../../assets/images/icon_default_profile.svg"
import { logout } from "../../redux/slices/authSlice";
import { clearUserInfo } from "../../redux/slices/userSlice";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../modals/ConfirmModal";


const Header = () => {
    const [show, setShow] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation()
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state?.user?.info)
    const dispatch = useDispatch()

    const handleToggle = (nextShow: boolean) => {
        setShow(nextShow);
    };
    console.log("user.profile_pic", user?.profile_pic);


    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <header className="site-header">
                <Container fluid className='header-nav'>
                    <Navbar expand="lg">
                        <Navbar.Brand className="me-5 mt-1">
                            <img src={Logo} width={230} height={55} alt='SaferStops' />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />

                        <div className="tagline">{user?.truckStopOwner?.site?.name}</div>

                        <div className="d-flex align-items-center ms-auto gap-3">

                            <div ref={dropdownRef} className="relative prodile-menu-btn">
                                <Button
                                    onClick={() => setDropdownOpen(!dropdownOpen)}
                                    className="flex items-center text-sm pe-1 mt-1 px-0 font-medium text-heading rounded-full hover:text-fg-brand md:me-0 focus:ring-4 focus:ring-neutral-tertiary"
                                    type="button"
                                >
                                    <span className="sr-only">{t('open_user_menu')}</span>
                                    <img
                                        src={user?.profile_pic ? user.profile_pic : defaultProfle}
                                        width={30}
                                        height={30}
                                        className="rounded-full h-9 w-9 flex bg-teal-400 m-2 object-fit-cover"
                                        alt=""
                                    />
                                    <span className="mr-2">{[user?.truckStopOwner?.first_name, user?.truckStopOwner?.surname].filter(Boolean).join(' ')}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12.8057 12.75L11.473 14.0828C11.3347 14.2213 11.2671 14.3937 11.2703 14.6C11.2734 14.8063 11.3442 14.9788 11.4827 15.1173C11.6213 15.2558 11.7958 15.325 12.0065 15.325C12.2172 15.325 12.3907 15.2558 12.527 15.1173L15.0115 12.6328C15.1923 12.4519 15.2828 12.241 15.2828 12C15.2828 11.759 15.1923 11.5481 15.0115 11.3673L12.5173 8.873C12.3787 8.73467 12.2063 8.6655 12 8.6655C11.7937 8.6655 11.6213 8.73467 11.4827 8.873C11.3442 9.0115 11.275 9.18608 11.275 9.39675C11.275 9.60742 11.3442 9.78092 11.4827 9.91725L12.8057 11.25H9C8.7875 11.25 8.60942 11.3219 8.46575 11.4658C8.32192 11.6096 8.25 11.7878 8.25 12.0003C8.25 12.2129 8.32192 12.391 8.46575 12.5345C8.60942 12.6782 8.7875 12.75 9 12.75H12.8057Z" fill="#111111" fill-opacity="0.8" />
                                    </svg>
                                </Button>

                                <div className={`absolute right-0 z-10 ${dropdownOpen ? 'block' : 'hidden'} bg-white border border-default-medium rounded-base shadow-lg w-72`} style={{ marginTop: '17px' }}>

                                    <ul className="px-2 pb-2 text-sm text-body font-medium" aria-labelledby="dropdownAvatarNameButton">
                                        <li>
                                            <a href="/my-profile" className="inline-flex items-center w-full p-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded">
                                                <svg className="w-4 h-4 me-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg>
                                                {t('my_profile')}
                                            </a>
                                        </li>

                                        <li>
                                            <a href="#" className="inline-flex items-center w-full p-2 text-fg-danger hover:bg-neutral-tertiary-medium rounded"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setShowLogoutModal(true);
                                                    setDropdownOpen(false);
                                                }}>
                                                <svg className="w-4 h-4 me-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2" /></svg>
                                                {t('logout')}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </Navbar>
                </Container>
            </header>

            {/* Logout Confirmation Modal */}
            <ConfirmModal
                open={showLogoutModal}
                title="Confirm Logout"
                description="Are you sure you want to logout? You will need to login again to access your account."
                icon={
                    <svg className="w-8 h-8 text-red-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2" />
                    </svg>
                }
                confirmText="Logout"
                cancelText="Cancel"
                onConfirm={() => {
                    // navigate("/login");
                    navigate("/inititalScreen");
                    dispatch(logout());
                    dispatch(clearUserInfo());
                    setShowLogoutModal(false);
                }}
                onClose={() => setShowLogoutModal(false)}
            />

        </>
    )
}
export default Header;